import { Component, OnInit } from '@angular/core';
import { ServicioService, UsuariosService } from '../../servicios/index.service';
import { NotificacionesTabla } from '../Config/notify_msj.config';
declare var $;
declare var tabla_notificacion;

@Component({
  selector: 'app-notifi',
  templateUrl: 'notificaciones.component.html',
})
export class NotificacionesComponent implements OnInit {

  notificaciones:any;
  mensaje:any= [];
  notify_1:string = "NOTIFY_1";
  notify_2:string = "NOTIFY_2";
  notify_3:string = "NOTIFY_3";
  notify_4:string = "NOTIFY_4";
  notify_5:string = "NOTIFY_5";
  notify_6:string = "NOTIFY_6";
  notify_7:string = "NOTIFY_7";
  notify_panic:string = "PANIC";
  gif:boolean = true;

  constructor(private _servicio:ServicioService, private _usuario:UsuariosService) {

    document.getElementById('body').className = 'hold-transition skin-blue sidebar-mini sidebar-collapse';

  }

  ngOnInit() {

    this.mensaje = NotificacionesTabla;

    $(document).ready(function() {
      $("body").css("overflow","auto");
    });

    this._usuario.consult_notificaciones().subscribe(data=>{
      this.notificaciones = data;
      if( this.notificaciones ){

        this.gif = false;
        if( typeof tabla_notificacion !== 'function' ){
          this.settime();
        }
      }
    });


  }
  boorarNotify(){
    let txt;
    let r = confirm("El historial de notificaciones será borrado por completo. ¿Realmente quieres borrarlo?");
    if (r == true) {
        this._servicio.borrarNotificaciones().subscribe(data=>{
          if(data == null){
            this.notificacion("El historial se borro correctamente", "primary");
          }else{
            this.notificacion("Ocurrió un error al borrar las notificaciones", "danger");
          }
        });
    } else {
        this.notificacion("La eliminación de notificaciones fue cancelada", "warning");
    }
  }

  settime(){
    setTimeout(function(){

    function tabla_notificacion(){
        $("#example1").DataTable();
        $('#example2').DataTable({
          "paging": true,
          "lengthChange": false,
          "searching": false,
          "ordering": true,
          "info": true,
          "autoWidth": false,
          "order": [[ 6, 'desc']]
        });
        $("#example2").removeAttr("id");
      }
      tabla_notificacion();
    },1500);
  }

  notificacion(text:string, tipo:string){
    if( tipo == "primary" ){
      $.notify({
        icon: 'fa fa-bell',
        title:"<b>Notificaciones</b><br>",
        message:text
      },{
        timer: 10000
      });
    }else{
      $.notify({
        icon: 'fa fa-bell',
        title:"<b>Notificaciones</b><br>",
        message:text
      },{
        timer: 10000,
        type:tipo
      });
    }
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/notificaciones/notificaciones.component.ts